module.exports = __webpack_public_path__ + "home-logo-layout.1fbYtsSo.svg";